export default {"src":"/_next/static/media/infoIconBlack.b226d562.svg","height":13,"width":13};